// extracted by mini-css-extract-plugin
export var socials = "socialsContainer-module--socials--1_KUX";
export var textWrap = "socialsContainer-module--textWrap--SIFvB";
export var title = "socialsContainer-module--title--1R3cn";
export var subtitle = "socialsContainer-module--subtitle--3nvaq";